import { createRouter, createWebHistory } from "vue-router";
import SearchView from "@/views/SearchView.vue";
import { ensureRoleSet, isLoggedIn, refreshToken } from "@/login";
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "search",
      component: SearchView,
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/auth/LoginPage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("@/views/auth/LogoutPage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/auth",
      name: "auth",
      component: () => import("@/views/auth/AuthPage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/sf",
      name: "stralfors",
      component: () => import("@/views/StralforsSearchView.vue"),
    },
    {
      path: "/accounts",
      name: "accounts",
      component: () => import("@/views/RoleView.vue"),
    },
    {
      path: "/csaccounts",
      name: "csaccounts",
      component: () => import("@/views/CsRoleView.vue"),
    },
    {
      path: "/order/:id",
      name: "order",
      component: () => import("@/views/OrderView.vue"),
    },
    {
      path: "/order/:id/log",
      name: "orderlog",
      component: () => import("@/views/OrderLogView.vue"),
    },
    {
      path: "/order/:id/data",
      name: "orderlog",
      component: () => import("@/views/OrderDataView.vue"),
    },
    {
      path: "/order/:id/status",
      name: "orderstatus",
      component: () => import("@/views/OrderStatusView.vue"),
    },
    {
      path: "/order/:id/receipt",
      name: "receipt",
      component: () => import("@/views/ReceiptView.vue"),
    },
    {
      path: "/device/:id",
      name: "device",
      component: () => import("@/views/DeviceView.vue"),
    },
    {
      path: "/device/:id/migrate",
      name: "migratedevice",
      component: () => import("@/views/DeviceMigrateView.vue"),
    },
    {
      path: "/legacydevice/:id",
      name: "legacydevice",
      component: () => import("@/views/LegacyDeviceView.vue"),
    },
    {
      path: "/legacydevice/:id/migrate",
      name: "migratelegacydevice",
      component: () => import("@/views/LegacyDeviceMigrateView.vue"),
    },
    {
      path: "/images",
      name: "images",
      component: () => import("@/views/image/ImagesView.vue"),
    },
    {
      path: "/frames",
      name: "frames",
      component: () => import("@/views/image/FramesView.vue"),
    },
    {
      path: "/categories",
      name: "categories",
      component: () => import("@/views/image/CategoriesView.vue"),
    },
    {
      path: "/images/:id",
      name: "editimage",
      component: () => import("@/components/image/EditImage.vue"),
    },
    {
      path: "/frames/:id",
      name: "editframe",
      component: () => import("@/components/image/EditFrame.vue"),
    },
    {
      path: "/framesByGroup/:id",
      name: "editframeGroup",
      component: () => import("@/components/image/EditFrameGroup.vue"),
    },
    {
      path: "/categories/:id",
      name: "editcategory",
      component: () => import("@/components/image/EditCategory.vue"),
    },

    {
      path: "/uploadframes",
      name: "uploadframes",
      component: () => import("@/components/image/UploadFrames.vue"),
    },
    {
      path: "/uploadimages",
      name: "uploadimages",
      component: () => import("@/components/image/UploadImages.vue"),
    },
    {
      path: "/cspromotions",
      name: "cspromotions",
      component: () => import("@/views/CsPromotionsView.vue"),
    },
    {
      path: "/promotions",
      name: "promotions",
      component: () => import("@/views/PromotionsView.vue"),
    },
    {
      path: "/newsletter",
      name: "newsletter",
      component: () => import("@/views/NewsletterView.vue"),
    },
    {
      path: "/broadcast",
      name: "broadcast",
      component: () => import("@/views/BroadcastView.vue"),
    },
    {
      path: "/systemlog",
      name: "systemlog",
      component: () => import("@/views/SystemLogView.vue"),
    },
    {
      path: "/broadcast/:platform/:id",
      name: "editbroadcast",
      component: () => import("@/components/message/MessageEditor.vue"),
    },
    /*    {
      path: "/statistics",
      name: "statistics",
      component: () => import("@/views/StatisticsView.vue"),
    },*/
    {
      path: "/user/:id",
      name: "user",
      component: () => import("@/views/UserView.vue"),
    },
    {
      path: "/user/:id/receivers",
      name: "userreceivers",
      component: () => import("@/views/UserReceiversView.vue"),
    },
    {
      path: "/legacy",
      name: "legacy",
      component: () => import("@/views/LegacyLogView.vue"),
    },
    {
      path: "/timeline",
      name: "timeline",
      component: () => import("@/views/LegacyTimelineView.vue"),
    },
    {
      path: "/stacktrace",
      name: "stacktrace",
      component: () => import("@/views/StacktraceView.vue"),
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () => import("@/components/message/NotificationSender.vue"),
    },
    {
      path: "/remoteConfigs",
      name: "remoteConfig",
      component: () => import("@/views/RemoteConfigView.vue"),
    },
    {
      path: "/stickers",
      name: "stickers",
      component: () => import("@/views/stickers/AllStickerCollectionsView.vue"),
    },
    {
      path: "/tag-management",
      name: "tagManagement",
      component: () => import("@/views/TagManagementView.vue"),
    },
    {
      path: "/backside-template",
      name: "backsideTemplate",
      component: () => import("@/views/BacksideTemplateView.vue"),
    },
    {
      path: "/create-sticker-collection",
      name: "create-sticker-collection",
      component: () =>
        import("@/views/stickers/CreateStickerCollectionView.vue"),
    },
    {
      path: "/edit-sticker-collection/:id",
      name: "edit-sticker-collection",
      component: () => import("@/views/stickers/EditStickerCollectionView.vue"),
    },
    {
      path: "/sticker-collection/:id",
      name: "stickerCollection",
      component: () => import("@/views/stickers/StickerCollectionView.vue"),
    },
    {
      path: "/mailout",
      name: "mailout",
      component: () => import("@/views/MailOutView.vue"),
    },
    {
      path: "/mailout/:id",
      name: "mailoutdetail",
      component: () => import("@/views/MailOutOrderDetailView.vue"),
    },
    {
      path: "/price-management",
      name: "priceManagement",
      component: () => import("@/views/PriceManagementView.vue"),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  try {
    if (to.matched.some((record) => record.meta.public)) {
      next();
    } else if (isLoggedIn()) {
      await ensureRoleSet();
      next();
    } else if (await refreshToken()) {
      await ensureRoleSet();
      next();
    } else {
      next({ name: "login", params: { redirect: to.fullPath } });
    }
  } catch (e) {
    console.log("got error in router");
    console.log(e);
  }
});

export default router;
